import { useQuery } from '@tanstack/react-query';

import { getProducts } from './getProducts';

export function useGetProducts() {
  return useQuery({
    queryKey: ['products'],
    queryFn: getProducts,
    staleTime: 10 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1
  });
}
